import React, { useRef, useEffect } from "react";
import { Button } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons"; // Using Ant Design's Environment icon for the map view
import "./style.css";

const CardsContainer = ({
  title,
  children,
  flexWrap = "nowrap",
  overflowX = "scroll",
  showMapViewButton = false,
  onMapViewClick,
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollLeft = 0;
    }
  }, []);

  const containerStyle = {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: flexWrap,
    overflowX: overflowX,
    paddingBottom: "1rem",
    marginBottom: "2rem",
  };

  return (
    <div className="cards-container">
      <h2 className="heading">{title}</h2>

      <div
        ref={containerRef}
        className="cards-container--div"
        style={containerStyle}
      >
        {children}
      </div>
      {showMapViewButton && (
        <div className="button-map-container">
          <h3 className="heading-map">
            View Geo-referenced Subproject progress updates on Map
          </h3>
          <Button
            icon={<EnvironmentOutlined />}
            onClick={onMapViewClick}
            className="map-view-button"
            data-cy="map-view-button"
          >
            View on Map
          </Button>
        </div>
      )}
    </div>
  );
};

export default CardsContainer;
